export const projectsList = [
  {
    id: 1,
    title: "Mobilié Scolaire & Maternelle & Collectivité",
    src:"images/project-1.jpg",
    link: "https://www.benhnia.tn",
  },
  {
    id: 2,
    title: "Fairtrade bois d'olivier",
    src:"images/project-2.png",
    link: "https://fairtradeboisolivier.com",
  },
  {
    id: 3,
    title: "Restaurant",
    src:"images/project-3.png",
    link: "https://www.foodhalal.ch",
  },
  {
    id: 4,
    title: "Fabrication Meubles",
    src:"images/project-4.png",
    link: "http://legeneral-industriel.tn/",
  },
  {
    id: 5,
    src:"images/project-5.jpg",
    title: "News - Business News Portal",
  },
  {
    id: 6,
    src:"images/project-6.jpg",
    title: "Auto Quarter - Car Repair Workshop",
  },
  {
    id: 7,
    src:"images/project-7.jpg",
    title: "Little Italy - Restaurant",
  },
  {
    id: 8,
    src:"images/project-8.jpg",
    title: "Impuls - Consulting Company",
  },
  {
    id: 9,
    src:"images/project-9.jpg",
    title: "Tour Up - Travel Agency",
  },
];
